import { render } from "./leaveDetail.vue?vue&type=template&id=413b6c2e&scoped=true"
import script from "./leaveDetail.vue?vue&type=script&lang=js"
export * from "./leaveDetail.vue?vue&type=script&lang=js"

import "./leaveDetail.vue?vue&type=style&index=0&id=413b6c2e&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413b6c2e"]])

export default __exports__